export default [
  {
    value: {
      maxSize: 100 * 1024
    },
    key: 1,
    label: '100K以内'
  },
  {
    value: {
      minSize: 100 * 1024,
      maxSize: 500 * 1024
    },
    key: 2,
    label: '100K-500K'
  },
  {
    value: {
      minSize: 500 * 1024,
      maxSize: 1024 * 1024
    },
    key: 3,
    label: '500K-1M'
  },
  {
    value: {
      minSize: 1024 * 1024,
      maxSize: 5 * 1024 * 1024
    },
    key: 4,
    label: '1M-5M'
  },
  {
    value: {
      minSize: 5 * 1024 * 1024,
      maxSize: 10 * 1024 * 1024
    },
    key: 5,
    label: '5M-10M'
  },
  {
    value: {
      minSize: 5 * 1024 * 1024,
      maxSize: 50 * 1024 * 1024
    },
    key: 6,
    label: '10M-50M'
  },
  {
    value: {
      minSize: 50 * 1024 * 1024
    },
    key: 7,
    label: '50M以上'
  }
]
